const Navigation = [
  {
    id: 'Dashboard',
    title: 'Dashboard',
    type: 'item',
    icon: 'dashboard',
    url: 'dashboard'
  },
  {
    id: 'Payments',
    title: 'Payments',
    type: 'item',
    icon: 'payment',
    url: '/payments',
    children: [
      {
        id: 'paymentList',
        title: 'Payment list',
        type: 'item',
        url: '/payments',
      },
      {
        id: 'createNewPayment',
        title: 'Create new payment',
        type: 'item',
        url: '/create-payment',
      }
    ],
  }
];

export default Navigation;
